module.exports = __webpack_public_path__ + "static/media/3.56d325c3.png";